import React from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { Calendar } from 'primereact/calendar';
import { InputTextarea } from 'primereact/inputtextarea';
import { AutoComplete } from 'primereact/autocomplete';
import csioLogo from 'images/CSIOLogo.jpg';
import CreateNewCarriers from '../CreateNewCarriers';
import AddNewSignature from '../AddNewSignature';
import { useSignatures } from '../../../../hooks/useSignatures';
import { useProducers } from '../ProducerSection';
import { useCertificateHolders } from '../../../certificate-holders/hooks/useCertificateHolders';

const CONTACT_TYPE_OPTIONS = [
  { label: 'Phone', value: 'phone' },
  { label: 'Fax', value: 'fax' },
  { label: 'Cell', value: 'cell' },
  { label: 'Home', value: 'home' },
];

export default function Csio0910eclForm() {
  const [showCreateCarrier, setShowCreateCarrier] = React.useState(false);
  const [showAddSignature, setShowAddSignature] = React.useState(false);

  const [holderLine1, setHolderLine1] = React.useState('');
  const [holderLine2, setHolderLine2] = React.useState('');
  const [holderLine3, setHolderLine3] = React.useState('');
  const [holderLine4, setHolderLine4] = React.useState('');
  const [holderSearchQuery, setHolderSearchQuery] = React.useState('');
  const { holders: holderSuggestions } = useCertificateHolders(holderSearchQuery, 10);
  const [insuredDropdown, setInsuredDropdown] = React.useState('');
  const [insuredName, setInsuredName] = React.useState('');
  const [insuredAddress, setInsuredAddress] = React.useState('');
  const [insuredCity, setInsuredCity] = React.useState('');
  const [insuredState, setInsuredState] = React.useState('');
  const [insuredZip, setInsuredZip] = React.useState('');
  const [insuredNA, setInsuredNA] = React.useState('');

  const [descriptionOfOps, setDescriptionOfOps] = React.useState('');
  const [cglClaimsMade, setCglClaimsMade] = React.useState(false);
  const [cglOccurrence, setCglOccurrence] = React.useState(false);
  const [cglProducts, setCglProducts] = React.useState(false);
  const [cglEmployersLiab, setCglEmployersLiab] = React.useState(false);
  const [cglCrossLiab, setCglCrossLiab] = React.useState(false);
  const [cglCustom1Check, setCglCustom1Check] = React.useState(false);
  const [cglCustom1Text, setCglCustom1Text] = React.useState('');
  const [cglCustom2Check, setCglCustom2Check] = React.useState(false);
  const [cglCustom2Text, setCglCustom2Text] = React.useState('');
  const [cglTenantsLegal, setCglTenantsLegal] = React.useState(false);
  const [cglPollutionLiab, setCglPollutionLiab] = React.useState(false);
  const [cglInsCompany, setCglInsCompany] = React.useState('');
  const [cglPolicyNumber, setCglPolicyNumber] = React.useState('');
  const [cglEffDate, setCglEffDate] = React.useState<Date | null>(null);
  const [cglExpDate, setCglExpDate] = React.useState<Date | null>(null);
  const [cglBiPdDed, setCglBiPdDed] = React.useState('');
  const [cglBiPdAmt, setCglBiPdAmt] = React.useState('');
  const [cglGenAggDed, setCglGenAggDed] = React.useState('');
  const [cglGenAggAmt, setCglGenAggAmt] = React.useState('');
  const [cglEachOccDed, setCglEachOccDed] = React.useState('');
  const [cglEachOccAmt, setCglEachOccAmt] = React.useState('');
  const [cglProdAggDed, setCglProdAggDed] = React.useState('');
  const [cglProdAggAmt, setCglProdAggAmt] = React.useState('');
  const [cglPersonalInjCheck, setCglPersonalInjCheck] = React.useState(false);
  const [cglPersonalInjDed, setCglPersonalInjDed] = React.useState('');
  const [cglPersonalInjAmt, setCglPersonalInjAmt] = React.useState('');
  const [cglPersonalAdvCheck, setCglPersonalAdvCheck] = React.useState(false);
  const [cglPersonalAdvDed, setCglPersonalAdvDed] = React.useState('');
  const [cglPersonalAdvAmt, setCglPersonalAdvAmt] = React.useState('');
  const [cglMedPayDed, setCglMedPayDed] = React.useState('');
  const [cglMedPayAmt, setCglMedPayAmt] = React.useState('');
  const [cglTenantsDed, setCglTenantsDed] = React.useState('');
  const [cglTenantsAmt, setCglTenantsAmt] = React.useState('');
  const [cglPollutionDed, setCglPollutionDed] = React.useState('');
  const [cglPollutionAmt, setCglPollutionAmt] = React.useState('');

  const [noaNonOwned, setNoaNonOwned] = React.useState(false);
  const [noaHired, setNoaHired] = React.useState(false);
  const [noaInsCompany, setNoaInsCompany] = React.useState('');
  const [noaPolicyNumber, setNoaPolicyNumber] = React.useState('');
  const [noaEffDate, setNoaEffDate] = React.useState<Date | null>(null);
  const [noaExpDate, setNoaExpDate] = React.useState<Date | null>(null);
  const [noaDed, setNoaDed] = React.useState('');
  const [noaAmt, setNoaAmt] = React.useState('');

  const [autoDescribed, setAutoDescribed] = React.useState(false);
  const [autoAllOwned, setAutoAllOwned] = React.useState(false);
  const [autoLeased, setAutoLeased] = React.useState(false);
  const [autoCustom1Check, setAutoCustom1Check] = React.useState(false);
  const [autoCustom1Text, setAutoCustom1Text] = React.useState('');
  const [autoCustom2Check, setAutoCustom2Check] = React.useState(false);
  const [autoCustom2Text, setAutoCustom2Text] = React.useState('');
  const [autoInsCompany, setAutoInsCompany] = React.useState('');
  const [autoPolicyNumber, setAutoPolicyNumber] = React.useState('');
  const [autoEffDate, setAutoEffDate] = React.useState<Date | null>(null);
  const [autoExpDate, setAutoExpDate] = React.useState<Date | null>(null);
  const [autoBiPdDed, setAutoBiPdDed] = React.useState('');
  const [autoBiPdAmt, setAutoBiPdAmt] = React.useState('');
  const [autoBiPersonDed, setAutoBiPersonDed] = React.useState('');
  const [autoBiPersonAmt, setAutoBiPersonAmt] = React.useState('');
  const [autoBiAccidentDed, setAutoBiAccidentDed] = React.useState('');
  const [autoBiAccidentAmt, setAutoBiAccidentAmt] = React.useState('');
  const [autoPropDmgDed, setAutoPropDmgDed] = React.useState('');
  const [autoPropDmgAmt, setAutoPropDmgAmt] = React.useState('');

  const [exUmbrella, setExUmbrella] = React.useState(false);
  const [exCustom1Check, setExCustom1Check] = React.useState(false);
  const [exCustom1Text, setExCustom1Text] = React.useState('');
  const [exInsCompany, setExInsCompany] = React.useState('');
  const [exPolicyNumber, setExPolicyNumber] = React.useState('');
  const [exEffDate, setExEffDate] = React.useState<Date | null>(null);
  const [exExpDate, setExExpDate] = React.useState<Date | null>(null);
  const [exEachOccDed, setExEachOccDed] = React.useState('');
  const [exEachOccAmt, setExEachOccAmt] = React.useState('');
  const [exAggDed, setExAggDed] = React.useState('');
  const [exAggAmt, setExAggAmt] = React.useState('');
  const [exCustomLabel, setExCustomLabel] = React.useState('');
  const [exCustomDed, setExCustomDed] = React.useState('');
  const [exCustomAmt, setExCustomAmt] = React.useState('');

  const [oth1CustomCheck, setOth1CustomCheck] = React.useState(false);
  const [oth1CustomText, setOth1CustomText] = React.useState('');
  const [oth1InsCompany, setOth1InsCompany] = React.useState('');
  const [oth1PolicyNumber, setOth1PolicyNumber] = React.useState('');
  const [oth1EffDate, setOth1EffDate] = React.useState<Date | null>(null);
  const [oth1ExpDate, setOth1ExpDate] = React.useState<Date | null>(null);
  const [oth1LimitLabel, setOth1LimitLabel] = React.useState('');
  const [oth1LimitDed, setOth1LimitDed] = React.useState('');
  const [oth1LimitAmt, setOth1LimitAmt] = React.useState('');
  const [oth2CustomCheck, setOth2CustomCheck] = React.useState(false);
  const [oth2CustomText, setOth2CustomText] = React.useState('');
  const [oth2InsCompany, setOth2InsCompany] = React.useState('');
  const [oth2PolicyNumber, setOth2PolicyNumber] = React.useState('');
  const [oth2EffDate, setOth2EffDate] = React.useState<Date | null>(null);
  const [oth2ExpDate, setOth2ExpDate] = React.useState<Date | null>(null);
  const [oth2LimitLabel, setOth2LimitLabel] = React.useState('');
  const [oth2LimitDed, setOth2LimitDed] = React.useState('');
  const [oth2LimitAmt, setOth2LimitAmt] = React.useState('');
  const [cancDays, setCancDays] = React.useState('');
  const [brokerDropdown, setBrokerDropdown] = React.useState('');
  const [brokerName, setBrokerName] = React.useState('');
  const [brokerAddress, setBrokerAddress] = React.useState('');
  const [brokerCity, setBrokerCity] = React.useState('');
  const [brokerState, setBrokerState] = React.useState('');
  const [brokerZip, setBrokerZip] = React.useState('');
  const [brokerClientId, setBrokerClientId] = React.useState('');
  
  // Get agencyLocationId from session storage for filtering
  const agencyLocationId = React.useMemo(() => {
    try {
      const stored = sessionStorage.getItem('selectedClient');
      if (stored) {
        const clientData = JSON.parse(stored);
        return clientData?.primaryLocationDatabaseId || undefined;
      }
    } catch {}
    return undefined;
  }, []);
  
  const { producers, producersLoading, producerOptions } = useProducers(agencyLocationId);

  const handleBrokerSelect = (id: string) => {
    setBrokerDropdown(id);
    const p = producers.find((x) => x.id === id);
    if (!p) return;
    setBrokerAddress(p.adressLine1 || '');
    setBrokerCity(p.city || '');
    setBrokerState(p.state || '');
    setBrokerZip(p.zip || '');
  };
  const [aiLine1, setAiLine1] = React.useState('');
  const [aiLine2, setAiLine2] = React.useState('');
  const [aiLine3, setAiLine3] = React.useState('');
  const [aiCity, setAiCity] = React.useState('');
  const [aiState, setAiState] = React.useState('');
  const [aiZip, setAiZip] = React.useState('');
  const [authIssuer, setAuthIssuer] = React.useState('');
  const [authRep, setAuthRep] = React.useState('');
  const [authSignature, setAuthSignature] = React.useState('');
  const { signatureOptions, refetchSignatures } = useSignatures();
  const [signaturePreviewUrl, setSignaturePreviewUrl] = React.useState('');
  React.useEffect(() => {
    if (!authSignature) { setSignaturePreviewUrl(''); return; }
    fetch(`${process.env.REACT_APP_COIPortal_Url}/api/igigcoi/signature-preview/${authSignature}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('igtoken') || ''}`,
        'Content-Type': 'application/json',
        NCToken: localStorage.getItem('NCToken') || '',
      },
    })
      .then(r => r.ok ? r.text() : Promise.reject())
      .then(url => setSignaturePreviewUrl(url.replace(/^"|"$/g, '')))
      .catch(() => setSignaturePreviewUrl(''));
  }, [authSignature]);
  const [contact1Type, setContact1Type] = React.useState('');
  const [contact1No, setContact1No] = React.useState('');
  const [contact2Type, setContact2Type] = React.useState('');
  const [contact2No, setContact2No] = React.useState('');
  const [contact3Type, setContact3Type] = React.useState('');
  const [contact3No, setContact3No] = React.useState('');
  const [contact4Type, setContact4Type] = React.useState('');
  const [contact4No, setContact4No] = React.useState('');
  const [certDate, setCertDate] = React.useState<Date | null>(new Date());
  const [authEmail, setAuthEmail] = React.useState('');

  const [descContinued, setDescContinued] = React.useState('');

  // ── Helpers ──
  const chk = (id: string, checked: boolean, setter: (v: boolean) => void, label: string) => (
    <div className="masterCert__checkboxItem">
      <Checkbox inputId={id} checked={checked} onChange={(e) => setter(e.checked ?? false)} />
      <label htmlFor={id} className="masterCert__checkboxItemLabel">{label}</label>
    </div>
  );

  const csioLimit = (label: string, dedVal: string, dedSet: (v: string) => void, amtVal: string, amtSet: (v: string) => void) => (
    <>
      <div className="csio__limitLabel">{label}</div>
      <InputText value={dedVal} onChange={(e) => dedSet(e.target.value)} placeholder="$" className="masterCert__input" />
      <InputText value={amtVal} onChange={(e) => amtSet(e.target.value)} placeholder="$" className="masterCert__input" />
    </>
  );

  const csioLimitCheck = (id: string, checked: boolean, setter: (v: boolean) => void, label: string, dedVal: string, dedSet: (v: string) => void, amtVal: string, amtSet: (v: string) => void) => (
    <>
      <div className="csio__limitCheckRow">
        <Checkbox inputId={id} checked={checked} onChange={(e) => setter(e.checked ?? false)} />
        <label htmlFor={id} className="csio__limitLabel">{label}</label>
      </div>
      <InputText value={dedVal} onChange={(e) => dedSet(e.target.value)} placeholder="$" className="masterCert__input" />
      <InputText value={amtVal} onChange={(e) => amtSet(e.target.value)} placeholder="$" className="masterCert__input" />
    </>
  );

  const sectionHeader = (num: string, title: string) => (
    <div className="csio__numberedHeader">
      <span className="csio__sectionNum">{num}</span>
      {title}
    </div>
  );

  return (
    <>
      <div className="masterCert__section">
        {/* CSIO HEADER */}
        <div className="masterCert__acordHeader">
          <img src={csioLogo} alt="CSIO" className="masterCert__acordLogo" />
          <div className="masterCert__acordTitleWrapper">
            <div className="masterCert__acordTitle">CERTIFICATE OF LIABILITY INSURANCE</div>
          </div>
          <div style={{ minWidth: 180 }} />
        </div>

        {/* DISCLAIMER */}
        <div className="masterCert__disclaimer">
          This certificate is issued as a matter of information only and confers no rights upon the certificate holder and imposes no liability on the insurer. This certificate does not amend, extend or alter the coverage afforded by the policies below.
        </div>

        {/* SECTIONS 1 & 2 */}
        <div className="masterCert__twoColumnLayout">
          {/* Section 1: Certificate Holder */}
          <div>
            {sectionHeader('1', 'CERTIFICATE HOLDER - NAME AND MAILING ADDRESS')}
            <div style={{ position: 'relative', width: '100%', marginBottom: 6 }}>
              <i className="pi pi-search" style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#6c757d', fontSize: 13, zIndex: 1, pointerEvents: 'none' }} />
              <AutoComplete
              value={holderSearchQuery}
              suggestions={holderSuggestions.map((h) => ({ label: h.name, value: h }))}
              completeMethod={(e) => setHolderSearchQuery(e.query)}
              onChange={(e) => { if (typeof e.value === 'string') setHolderSearchQuery(e.value); }}
              field="label"
              placeholder="Search for a certificate holder"
              style={{ width: '100%' }}
              inputStyle={{ width: '100%', paddingLeft: 30 }}
              onSelect={(e) => {
                const h = e.value.value;
                setHolderLine1(h.name || '');
                setHolderLine2(h.addressLine1 || '');
                setHolderLine3(h.addressLine2 || '');
                setHolderLine4([h.city, h.stateName, h.zipCode].filter(Boolean).join(', '));
                setHolderSearchQuery('');
              }}
            />
            </div>
            <InputText maxLength={100} value={holderLine1} onChange={(e) => setHolderLine1(e.target.value)} placeholder="Name" className="masterCert__input masterCert__inputFull masterCert__inputMbSm" />
            <InputText maxLength={100} value={holderLine2} onChange={(e) => setHolderLine2(e.target.value)} placeholder="Address line 1" className="masterCert__input masterCert__inputFull masterCert__inputMbSm" />
            <InputText maxLength={100} value={holderLine3} onChange={(e) => setHolderLine3(e.target.value)} placeholder="Address line 2" className="masterCert__input masterCert__inputFull masterCert__inputMbSm" />
            <InputText maxLength={100} value={holderLine4} onChange={(e) => setHolderLine4(e.target.value)} placeholder="City, province, postal code" className="masterCert__input masterCert__inputFull" />
          </div>

          {/* Section 2: Insured */}
          <div>
            {sectionHeader('2', "INSURED'S FULL NAME AND MAILING ADDRESS")}
            <Dropdown value={insuredDropdown} onChange={(e) => setInsuredDropdown(e.value)} options={[]} placeholder="Type and/or choose location" className="masterCert__input masterCert__inputFull masterCert__inputMbSm" editable emptyMessage="No available options" />
            <InputText maxLength={100} value={insuredName} onChange={(e) => setInsuredName(e.target.value)} placeholder="Full name" className="masterCert__input masterCert__inputFull masterCert__inputMbSm" />
            <InputText maxLength={100} value={insuredAddress} onChange={(e) => setInsuredAddress(e.target.value)} placeholder="Address" className="masterCert__input masterCert__inputFull masterCert__inputMbSm" />
            <div className="masterCert__addressGrid">
              <InputText maxLength={100} value={insuredCity} onChange={(e) => setInsuredCity(e.target.value)} placeholder="City" className="masterCert__input masterCert__inputFull" />
              <InputText maxLength={50} value={insuredState} onChange={(e) => setInsuredState(e.target.value)} placeholder="Province" className="masterCert__input masterCert__inputFull" />
              <InputText maxLength={20} value={insuredZip} onChange={(e) => setInsuredZip(e.target.value)} placeholder="Postal code" className="masterCert__input masterCert__inputFull" />
            </div>
            <div style={{ marginTop: 6 }}>
              <div className="masterCert__contactLabel">NA:</div>
              <InputText maxLength={250} value={insuredNA} onChange={(e) => setInsuredNA(e.target.value)} className="masterCert__input masterCert__inputFull" />
            </div>
          </div>
        </div>

        {/* Section 3: Description of Operations */}
        <div className="masterCert__descriptionSection">
          {sectionHeader('3', 'DESCRIPTION OF OPERATIONS / LOCATIONS / AUTOMOBILES / SPECIAL ITEMS TO WHICH THIS CERTIFICATE APPLIES')}
          <div className="masterCert__disclaimer" style={{ marginBottom: 8 }}>
            but only with respect to the operations of the Named Insured
          </div>
          <InputTextarea maxLength={2000} value={descriptionOfOps} onChange={(e) => setDescriptionOfOps(e.target.value)} rows={3} className="masterCert__descriptionTextarea" />
        </div>

        {/* ═══ Section 4: Coverages ═══ */}
        <div className="masterCert__coveragesSection">
          {sectionHeader('4', 'COVERAGES')}
          <div className="masterCert__disclaimer" style={{ marginBottom: 8 }}>
            The policies of insurance listed below have been issued to the insured named above for the policy period indicated. Notwithstanding any requirement, term or condition of any contract or other document with respect to which this certificate may be issued or may pertain, the insurance afforded by the policies described herein is subject to all the terms, exclusions and conditions of such policies.
          </div>
          <div className="masterCert__disclaimerImportant" style={{ marginBottom: 12 }}>
            <span className="masterCert__importantLabel">LIMITS SHOWN MAY HAVE BEEN REDUCED BY PAID CLAIMS</span>
          </div>

          {/* Coverage Table Header */}
          <div className="csio__covHeader">
            <div>TYPE OF INSURANCE</div>
            <div>INSURANCE COMPANY<br />AND POLICY NUMBER</div>
            <div style={{ textAlign: 'center' }}>EFFECTIVE<br />DATE</div>
            <div style={{ textAlign: 'center' }}>EXPIRY<br />DATE</div>
            <div>
              <div>LIMITS OF LIABILITY</div>
              <div style={{ fontSize: '0.6rem', color: '#555' }}>(Canadian dollars unless indicated otherwise)</div>
              <div className="csio__limitsSubHeader">
                <div>COVERAGE</div>
                <div>DED</div>
                <div>AMOUNT</div>
              </div>
            </div>
          </div>

          {/* ── COMMERCIAL GENERAL LIABILITY ── */}
          <div className="csio__covRow">
            <div>
              <div className="masterCert__coverageType">COMMERCIAL GENERAL LIABILITY</div>
              {chk('csioCglClaimsMade', cglClaimsMade, setCglClaimsMade, 'Claims Made')}
              {chk('csioCglOccurrence', cglOccurrence, setCglOccurrence, 'Occurrence')}
              {chk('csioCglProducts', cglProducts, setCglProducts, 'Products and/or completed operations')}
              {chk('csioCglEmployersLiab', cglEmployersLiab, setCglEmployersLiab, "Employer's Liability")}
              {chk('csioCglCrossLiab', cglCrossLiab, setCglCrossLiab, 'Cross Liability')}
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="csioCglCustom1" checked={cglCustom1Check} onChange={(e) => setCglCustom1Check(e.checked ?? false)} />
                <InputText value={cglCustom1Text} onChange={(e) => setCglCustom1Text(e.target.value)} className="masterCert__input masterCert__inputXs" />
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="csioCglCustom2" checked={cglCustom2Check} onChange={(e) => setCglCustom2Check(e.checked ?? false)} />
                <InputText value={cglCustom2Text} onChange={(e) => setCglCustom2Text(e.target.value)} className="masterCert__input masterCert__inputXs" />
              </div>
              {chk('csioCglTenantsLegal', cglTenantsLegal, setCglTenantsLegal, 'Tenants Legal Liability')}
              {chk('csioCglPollutionLiab', cglPollutionLiab, setCglPollutionLiab, 'Pollution Liability Extension')}
            </div>
            <div className="csio__insCoStack">
              <Dropdown value={cglInsCompany} onChange={(e) => setCglInsCompany(e.value)} options={[]} placeholder="Insurance company" className="masterCert__input masterCert__inputFull" editable emptyMessage="No available options" />
              <InputText maxLength={50} value={cglPolicyNumber} onChange={(e) => setCglPolicyNumber(e.target.value)} placeholder="Policy number" className="masterCert__input masterCert__inputFull" />
            </div>
            <div className="masterCert__dateCell">
              <Calendar value={cglEffDate} onChange={(e) => setCglEffDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="yy/mm/dd" />
            </div>
            <div className="masterCert__dateCell">
              <Calendar value={cglExpDate} onChange={(e) => setCglExpDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="yy/mm/dd" />
            </div>
            <div className="csio__limitsGrid">
              {csioLimit('Commercial General Liability Bodily Injury and Property Damage', cglBiPdDed, setCglBiPdDed, cglBiPdAmt, setCglBiPdAmt)}
              {csioLimit('Liability - General Aggregate', cglGenAggDed, setCglGenAggDed, cglGenAggAmt, setCglGenAggAmt)}
              {csioLimit('Liability - Each Occurrence', cglEachOccDed, setCglEachOccDed, cglEachOccAmt, setCglEachOccAmt)}
              {csioLimit('Products and Completed Operations AGG', cglProdAggDed, setCglProdAggDed, cglProdAggAmt, setCglProdAggAmt)}
              {csioLimitCheck('csioCglPersonalInj', cglPersonalInjCheck, setCglPersonalInjCheck, 'Personal Injury Liability', cglPersonalInjDed, setCglPersonalInjDed, cglPersonalInjAmt, setCglPersonalInjAmt)}
              {csioLimitCheck('csioCglPersonalAdv', cglPersonalAdvCheck, setCglPersonalAdvCheck, 'Personal And Advertising Injury Liability', cglPersonalAdvDed, setCglPersonalAdvDed, cglPersonalAdvAmt, setCglPersonalAdvAmt)}
              {csioLimit('Medical Payments', cglMedPayDed, setCglMedPayDed, cglMedPayAmt, setCglMedPayAmt)}
              {csioLimit('Tenants Legal Liability', cglTenantsDed, setCglTenantsDed, cglTenantsAmt, setCglTenantsAmt)}
              {csioLimit('Pollution Liability Extension', cglPollutionDed, setCglPollutionDed, cglPollutionAmt, setCglPollutionAmt)}
            </div>
          </div>

          {/* ── NON-OWNED AUTOMOBILE / HIRED AUTOMOBILES ── */}
          <div className="csio__covRow">
            <div>
              <div className="masterCert__coverageType">NON-OWNED AUTOMOBILE / HIRED AUTOMOBILES</div>
              {chk('csioNoaNonOwned', noaNonOwned, setNoaNonOwned, 'Non-Owned Automobile')}
              {chk('csioNoaHired', noaHired, setNoaHired, 'Hired Automobiles')}
            </div>
            <div className="csio__insCoStack">
              <Dropdown value={noaInsCompany} onChange={(e) => setNoaInsCompany(e.value)} options={[]} placeholder="Insurance company" className="masterCert__input masterCert__inputFull" editable emptyMessage="No available options" />
              <InputText maxLength={50} value={noaPolicyNumber} onChange={(e) => setNoaPolicyNumber(e.target.value)} placeholder="Policy number" className="masterCert__input masterCert__inputFull" />
            </div>
            <div className="masterCert__dateCell">
              <Calendar value={noaEffDate} onChange={(e) => setNoaEffDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="yy/mm/dd" />
            </div>
            <div className="masterCert__dateCell">
              <Calendar value={noaExpDate} onChange={(e) => setNoaExpDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="yy/mm/dd" />
            </div>
            <div className="csio__limitsGrid">
              {csioLimit('Non-Owned Automobile', noaDed, setNoaDed, noaAmt, setNoaAmt)}
            </div>
          </div>

          {/* ── AUTOMOBILE LIABILITY ── */}
          <div className="csio__covRow">
            <div>
              <div className="masterCert__coverageType">AUTOMOBILE LIABILITY</div>
              {chk('csioAutoDescribed', autoDescribed, setAutoDescribed, 'Described Automobiles')}
              {chk('csioAutoAllOwned', autoAllOwned, setAutoAllOwned, 'All Owned Automobiles')}
              {chk('csioAutoLeased', autoLeased, setAutoLeased, 'Leased Automobiles **')}
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="csioAutoCustom1" checked={autoCustom1Check} onChange={(e) => setAutoCustom1Check(e.checked ?? false)} />
                <InputText value={autoCustom1Text} onChange={(e) => setAutoCustom1Text(e.target.value)} className="masterCert__input masterCert__inputXs" />
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="csioAutoCustom2" checked={autoCustom2Check} onChange={(e) => setAutoCustom2Check(e.checked ?? false)} />
                <InputText value={autoCustom2Text} onChange={(e) => setAutoCustom2Text(e.target.value)} className="masterCert__input masterCert__inputXs" />
              </div>
              <div className="csio__footnote">** All Automobiles leased in excess of 30 days where the insured is required to provide Insurance</div>
            </div>
            <div className="csio__insCoStack">
              <Dropdown value={autoInsCompany} onChange={(e) => setAutoInsCompany(e.value)} options={[]} placeholder="Insurance company" className="masterCert__input masterCert__inputFull" editable emptyMessage="No available options" />
              <InputText maxLength={50} value={autoPolicyNumber} onChange={(e) => setAutoPolicyNumber(e.target.value)} placeholder="Policy number" className="masterCert__input masterCert__inputFull" />
            </div>
            <div className="masterCert__dateCell">
              <Calendar value={autoEffDate} onChange={(e) => setAutoEffDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="yy/mm/dd" />
            </div>
            <div className="masterCert__dateCell">
              <Calendar value={autoExpDate} onChange={(e) => setAutoExpDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="yy/mm/dd" />
            </div>
            <div className="csio__limitsGrid">
              {csioLimit('Bodily Injury and Property Damage Combined', autoBiPdDed, setAutoBiPdDed, autoBiPdAmt, setAutoBiPdAmt)}
              {csioLimit('Bodily Injury (Per Person)', autoBiPersonDed, setAutoBiPersonDed, autoBiPersonAmt, setAutoBiPersonAmt)}
              {csioLimit('Bodily Injury (Per Accident)', autoBiAccidentDed, setAutoBiAccidentDed, autoBiAccidentAmt, setAutoBiAccidentAmt)}
              {csioLimit('Property Damage', autoPropDmgDed, setAutoPropDmgDed, autoPropDmgAmt, setAutoPropDmgAmt)}
            </div>
          </div>

          {/* ── EXCESS LIABILITY ── */}
          <div className="csio__covRow">
            <div>
              <div className="masterCert__coverageType">EXCESS LIABILITY</div>
              {chk('csioExUmbrella', exUmbrella, setExUmbrella, 'Umbrella Form')}
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="csioExCustom1" checked={exCustom1Check} onChange={(e) => setExCustom1Check(e.checked ?? false)} />
                <InputText value={exCustom1Text} onChange={(e) => setExCustom1Text(e.target.value)} className="masterCert__input masterCert__inputXs" />
              </div>
            </div>
            <div className="csio__insCoStack">
              <Dropdown value={exInsCompany} onChange={(e) => setExInsCompany(e.value)} options={[]} placeholder="Insurance company" className="masterCert__input masterCert__inputFull" editable emptyMessage="No available options" />
              <InputText maxLength={50} value={exPolicyNumber} onChange={(e) => setExPolicyNumber(e.target.value)} placeholder="Policy number" className="masterCert__input masterCert__inputFull" />
            </div>
            <div className="masterCert__dateCell">
              <Calendar value={exEffDate} onChange={(e) => setExEffDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="yy/mm/dd" />
            </div>
            <div className="masterCert__dateCell">
              <Calendar value={exExpDate} onChange={(e) => setExExpDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="yy/mm/dd" />
            </div>
            <div className="csio__limitsGrid">
              {csioLimit('Each Occurrence', exEachOccDed, setExEachOccDed, exEachOccAmt, setExEachOccAmt)}
              {csioLimit('Aggregate', exAggDed, setExAggDed, exAggAmt, setExAggAmt)}
              <InputText value={exCustomLabel} onChange={(e) => setExCustomLabel(e.target.value)} className="masterCert__input" placeholder="Coverage" />
              <InputText value={exCustomDed} onChange={(e) => setExCustomDed(e.target.value)} placeholder="$" className="masterCert__input" />
              <InputText value={exCustomAmt} onChange={(e) => setExCustomAmt(e.target.value)} placeholder="$" className="masterCert__input" />
            </div>
          </div>

          {/* ── OTHER LIABILITY 1 ── */}
          <div className="csio__covRow">
            <div>
              <div className="masterCert__coverageType">OTHER LIABILITY</div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="csioOth1Custom" checked={oth1CustomCheck} onChange={(e) => setOth1CustomCheck(e.checked ?? false)} />
                <InputText value={oth1CustomText} onChange={(e) => setOth1CustomText(e.target.value)} className="masterCert__input masterCert__inputXs" />
              </div>
            </div>
            <div className="csio__insCoStack">
              <Dropdown value={oth1InsCompany} onChange={(e) => setOth1InsCompany(e.value)} options={[]} placeholder="Insurance company" className="masterCert__input masterCert__inputFull" editable emptyMessage="No available options" />
              <InputText maxLength={50} value={oth1PolicyNumber} onChange={(e) => setOth1PolicyNumber(e.target.value)} placeholder="Policy number" className="masterCert__input masterCert__inputFull" />
            </div>
            <div className="masterCert__dateCell">
              <Calendar value={oth1EffDate} onChange={(e) => setOth1EffDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="yy/mm/dd" />
            </div>
            <div className="masterCert__dateCell">
              <Calendar value={oth1ExpDate} onChange={(e) => setOth1ExpDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="yy/mm/dd" />
            </div>
            <div className="csio__limitsGrid">
              <InputText value={oth1LimitLabel} onChange={(e) => setOth1LimitLabel(e.target.value)} placeholder="Coverage" className="masterCert__input" />
              <InputText value={oth1LimitDed} onChange={(e) => setOth1LimitDed(e.target.value)} placeholder="$" className="masterCert__input" />
              <InputText value={oth1LimitAmt} onChange={(e) => setOth1LimitAmt(e.target.value)} placeholder="$" className="masterCert__input" />
            </div>
          </div>

          {/* ── OTHER LIABILITY 2 ── */}
          <div className="csio__covRow">
            <div>
              <div className="masterCert__coverageType">OTHER LIABILITY</div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="csioOth2Custom" checked={oth2CustomCheck} onChange={(e) => setOth2CustomCheck(e.checked ?? false)} />
                <InputText value={oth2CustomText} onChange={(e) => setOth2CustomText(e.target.value)} className="masterCert__input masterCert__inputXs" />
              </div>
            </div>
            <div className="csio__insCoStack">
              <Dropdown value={oth2InsCompany} onChange={(e) => setOth2InsCompany(e.value)} options={[]} placeholder="Insurance company" className="masterCert__input masterCert__inputFull" editable emptyMessage="No available options" />
              <InputText maxLength={50} value={oth2PolicyNumber} onChange={(e) => setOth2PolicyNumber(e.target.value)} placeholder="Policy number" className="masterCert__input masterCert__inputFull" />
            </div>
            <div className="masterCert__dateCell">
              <Calendar value={oth2EffDate} onChange={(e) => setOth2EffDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="yy/mm/dd" />
            </div>
            <div className="masterCert__dateCell">
              <Calendar value={oth2ExpDate} onChange={(e) => setOth2ExpDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="yy/mm/dd" />
            </div>
            <div className="csio__limitsGrid">
              <InputText value={oth2LimitLabel} onChange={(e) => setOth2LimitLabel(e.target.value)} placeholder="Coverage" className="masterCert__input" />
              <InputText value={oth2LimitDed} onChange={(e) => setOth2LimitDed(e.target.value)} placeholder="$" className="masterCert__input" />
              <InputText value={oth2LimitAmt} onChange={(e) => setOth2LimitAmt(e.target.value)} placeholder="$" className="masterCert__input" />
            </div>
          </div>
        </div>

        {/* ═══ Section 5: Cancellation ═══ */}
        <div style={{ marginBottom: 16 }}>
          {sectionHeader('5', 'CANCELLATION')}
          <div className="masterCert__cancellationText">
            Should any of the above described policies be cancelled before the expiration date thereof, the issuing company will endeavor to mail{' '}
            <InputText maxLength={30} value={cancDays} onChange={(e) => setCancDays(e.target.value)} className="masterCert__input" style={{ width: 50, display: 'inline-block', margin: '0 4px', verticalAlign: 'middle' }} />{' '}
            days written notice to the certificate holder named above, but failure to mail such notice shall impose no obligation or liability of any kind upon the company, its agents or representatives.
          </div>
        </div>

        {/* ═══ Sections 6 & 7 ═══ */}
        <div className="csio__bottomTwoCol">
          {/* Section 6: Brokerage/Agency */}
          <div>
            {sectionHeader('6', 'BROKERAGE / AGENCY FULL NAME AND MAILING ADDRESS')}
            <Dropdown value={brokerDropdown} onChange={(e) => handleBrokerSelect(e.value)} options={producerOptions} placeholder={producersLoading ? 'Loading...' : 'Select brokerage / agency'} disabled={producersLoading} filter className="masterCert__input masterCert__inputFull masterCert__inputMbSm" emptyMessage="No available options" emptyFilterMessage="No available options" />
            <InputText maxLength={100} value={brokerName} onChange={(e) => setBrokerName(e.target.value)} placeholder="Full name" className="masterCert__input masterCert__inputFull masterCert__inputMbSm" />
            <InputText maxLength={100} value={brokerAddress} onChange={(e) => setBrokerAddress(e.target.value)} placeholder="Address" className="masterCert__input masterCert__inputFull masterCert__inputMbSm" />
            <div className="masterCert__addressGrid">
              <InputText maxLength={100} value={brokerCity} onChange={(e) => setBrokerCity(e.target.value)} placeholder="City" className="masterCert__input masterCert__inputFull" />
              <InputText maxLength={50} value={brokerState} onChange={(e) => setBrokerState(e.target.value)} placeholder="Province" className="masterCert__input masterCert__inputFull" />
              <InputText maxLength={20} value={brokerZip} onChange={(e) => setBrokerZip(e.target.value)} placeholder="Postal code" className="masterCert__input masterCert__inputFull" />
            </div>
            <div style={{ marginTop: 8 }}>
              <div className="masterCert__contactLabel">BROKER CLIENT ID:</div>
              <InputText maxLength={30} value={brokerClientId} onChange={(e) => setBrokerClientId(e.target.value)} className="masterCert__input masterCert__inputFull" />
            </div>
          </div>

          {/* Section 7: Additional Insured */}
          <div>
            {sectionHeader('7', 'ADDITIONAL INSURED NAME AND MAILING ADDRESS')}
            <div className="masterCert__disclaimer" style={{ marginBottom: 8 }}>
              but only with respect to the operations of the Named Insured
            </div>
            <InputText maxLength={100} value={aiLine1} onChange={(e) => setAiLine1(e.target.value)} placeholder="Name" className="masterCert__input masterCert__inputFull masterCert__inputMbSm" />
            <InputText maxLength={100} value={aiLine2} onChange={(e) => setAiLine2(e.target.value)} placeholder="Address line 1" className="masterCert__input masterCert__inputFull masterCert__inputMbSm" />
            <InputText maxLength={100} value={aiLine3} onChange={(e) => setAiLine3(e.target.value)} placeholder="Address line 2" className="masterCert__input masterCert__inputFull masterCert__inputMbSm" />
            <div className="masterCert__addressGrid">
              <InputText maxLength={100} value={aiCity} onChange={(e) => setAiCity(e.target.value)} placeholder="City" className="masterCert__input masterCert__inputFull" />
              <InputText maxLength={50} value={aiState} onChange={(e) => setAiState(e.target.value)} placeholder="Province" className="masterCert__input masterCert__inputFull" />
              <InputText maxLength={20} value={aiZip} onChange={(e) => setAiZip(e.target.value)} placeholder="Postal code" className="masterCert__input masterCert__inputFull" />
            </div>
          </div>
        </div>

        {/* ═══ Section 8: Certificate Authorization ═══ */}
        <div style={{ marginBottom: 16 }}>
          {sectionHeader('8', 'CERTIFICATE AUTHORIZATION')}
          <div className="csio__certAuthGrid">
            <div>
              <div className="masterCert__contactLabel">Issuer:</div>
              <InputText maxLength={100} value={authIssuer} onChange={(e) => setAuthIssuer(e.target.value)} className="masterCert__input masterCert__inputFull masterCert__inputMbSm" />
              <div className="masterCert__contactLabel">Authorized Representative:</div>
              <InputText maxLength={100} value={authRep} onChange={(e) => setAuthRep(e.target.value)} className="masterCert__input masterCert__inputFull masterCert__inputMbSm" />
              <div className="masterCert__contactLabel">Signature of Authorized Representative:</div>
              <div className="masterCert__authRepRow">
                <Dropdown value={authSignature} onChange={(e) => setAuthSignature(e.value)} options={signatureOptions} optionLabel="label" optionValue="value" placeholder="Select signature:" className="masterCert__input masterCert__authRepDropdown" emptyMessage="No available options" />
                <Button label="Create New" className="p-button-outlined carrierDialog__secondaryBtn" onClick={() => setShowAddSignature(true)} />
              </div>
              {signaturePreviewUrl && (
                <div style={{ marginTop: 8 }}>
                  <img src={signaturePreviewUrl} alt="Signature preview" style={{ maxHeight: 60, maxWidth: 280, objectFit: 'contain', border: '1px solid #e5e7eb', borderRadius: 6, padding: '4px 8px', background: '#fff' }} />
                </div>
              )}
            </div>
            <div>
              <div className="masterCert__contactLabel">Contact Number(s):</div>
              <div className="csio__contactRow">
                <Dropdown value={contact1Type} onChange={(e) => setContact1Type(e.value)} options={CONTACT_TYPE_OPTIONS} placeholder="Type" className="masterCert__input masterCert__inputFull" emptyMessage="No available options" />
                <InputText maxLength={20} value={contact1No} onChange={(e) => setContact1No(e.target.value)} placeholder="No" className="masterCert__input masterCert__inputFull" />
              </div>
              <div className="csio__contactRow">
                <Dropdown value={contact2Type} onChange={(e) => setContact2Type(e.value)} options={CONTACT_TYPE_OPTIONS} placeholder="Type" className="masterCert__input masterCert__inputFull" emptyMessage="No available options" />
                <InputText maxLength={20} value={contact2No} onChange={(e) => setContact2No(e.target.value)} placeholder="No" className="masterCert__input masterCert__inputFull" />
              </div>
              <div className="csio__contactRow">
                <Dropdown value={contact3Type} onChange={(e) => setContact3Type(e.value)} options={CONTACT_TYPE_OPTIONS} placeholder="Type" className="masterCert__input masterCert__inputFull" emptyMessage="No available options" />
                <InputText maxLength={20} value={contact3No} onChange={(e) => setContact3No(e.target.value)} placeholder="No" className="masterCert__input masterCert__inputFull" />
              </div>
              <div className="csio__contactRow">
                <Dropdown value={contact4Type} onChange={(e) => setContact4Type(e.value)} options={CONTACT_TYPE_OPTIONS} placeholder="Type" className="masterCert__input masterCert__inputFull" emptyMessage="No available options" />
                <InputText maxLength={20} value={contact4No} onChange={(e) => setContact4No(e.target.value)} placeholder="No" className="masterCert__input masterCert__inputFull" />
              </div>
              <div style={{ marginTop: 8 }}>
                <div className="masterCert__contactLabel">Certificate Date:</div>
                <div className="masterCert__dateCell">
                  <Calendar value={certDate} onChange={(e) => setCertDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="yy/mm/dd" />
                </div>
              </div>
              <div style={{ marginTop: 8 }}>
                <div className="masterCert__contactLabel">E-Mail Address:</div>
                <InputText maxLength={100} value={authEmail} onChange={(e) => setAuthEmail(e.target.value)} className="masterCert__input masterCert__inputFull" />
              </div>
            </div>
          </div>
        </div>

        {/* CSIO Footer */}
        <div className="masterCert__acordFooter">
          <div>CSIO C0910ECL - CERTIFICATE OF LIABILITY INSURANCE - 2010/09</div>
          <div>&copy; 2010, Centre for Study of Insurance Operations. All rights reserved.</div>
        </div>
      </div>

      {/* ═══ DESCRIPTIONS Continued ═══ */}
      <div className="masterCert__section" style={{ marginTop: 24 }}>
        <div className="masterCert__sectionHeader">DESCRIPTIONS Continued</div>
        <InputTextarea maxLength={2000} value={descContinued} onChange={(e) => setDescContinued(e.target.value)} rows={6} className="masterCert__descriptionTextarea" />
      </div>

      <CreateNewCarriers open={showCreateCarrier} onClose={() => setShowCreateCarrier(false)} />
      <AddNewSignature open={showAddSignature} onClose={() => setShowAddSignature(false)} onSaved={refetchSignatures} />
    </>
  );
}
